import {useCallback, useRef} from 'react'

export function useInteractionTiming() {
  const interactionStart = useRef<number | null>(null)
  const markInteractionStart = useCallback(() => {
    interactionStart.current = Date.now()
  }, [])
  const resetInteractionStart = useCallback(() => {
    interactionStart.current = null
  }, [])

  return [interactionStart, markInteractionStart, resetInteractionStart] as const
}
